var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToothRestorationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 204,
    viewBox: "0 0 204 204",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_45_2674)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 102,
    cy: 98,
    r: 45,
    fill: "#0587E4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.4261 99.4036C90.8081 100.381 94.344 100.892 97.9379 100.892H102.166C106.803 100.892 111.362 100.212 115.712 98.9098C115.503 99.7992 115.385 100.634 115.421 101.374C115.543 103.822 115.543 109.481 115.421 118.351C115.421 121.59 112.774 124.217 109.51 124.217C106.245 124.217 103.598 121.59 103.598 118.351V106.711C103.598 105.631 102.716 104.756 101.627 104.756C100.539 104.756 99.6567 105.631 99.6567 106.711V118.351C99.6567 121.59 97.01 124.217 93.745 124.217C90.4805 124.217 87.8333 121.59 87.8333 118.351C87.8756 109.945 87.8756 104.471 87.8333 101.926C87.821 101.167 87.6654 100.314 87.4269 99.4045L87.4261 99.4036ZM85.8977 94.7696C85.0499 92.352 84.2843 89.9568 84.4727 88.126C84.9489 83.5328 86.4235 81.2973 91.1065 79.9635C94.071 79.1193 98.9112 80.4715 101.487 82.3004C104.061 80.4723 108.814 79.448 111.871 79.9667C115.901 80.6499 118.032 83.5389 118.495 88.1259C118.67 89.8199 117.961 92.0379 117.179 94.2946C112.427 96.0522 107.349 96.9806 102.166 96.9806H97.9376C93.7755 96.9806 89.6998 96.2159 85.8977 94.7696ZM91.3098 83.5368C90.0798 84.1076 87.9266 86.2029 88.61 90.0501L89.0739 92.6616C89.1926 93.3293 89.8589 93.7714 90.5182 93.6561C91.1796 93.5404 91.6508 92.8991 91.5322 92.2314L91.0683 89.6203C90.5646 86.7843 92.1783 85.8598 92.3803 85.7585C92.9781 85.4712 93.2092 84.7542 92.9288 84.1423C92.6468 83.5275 91.9193 83.2545 91.3097 83.5369L91.3098 83.5368ZM139.016 78.1117C139.377 77.7075 140 77.67 140.407 78.0282C140.814 78.3863 140.852 79.0043 140.491 79.4084L135.899 84.5528C127.179 94.3213 114.66 99.9137 101.509 99.9137H97.2809C86.8188 99.9137 76.8564 95.4708 69.9106 87.7067C67.0697 84.531 67.3607 79.6714 70.5604 76.8525C72.0688 75.5236 74.0397 74.8305 76.0546 74.9209C76.5981 74.9454 77.0189 75.4025 76.9943 75.9419C76.9697 76.4813 76.509 76.8989 75.9655 76.8745C74.4629 76.8073 72.9932 77.3239 71.8688 78.3147C69.4828 80.4169 69.266 84.0409 71.3844 86.4087C77.9566 93.7544 87.3822 97.9575 97.2813 97.9575H101.51C114.096 97.9575 126.078 92.6054 134.424 83.2558L139.016 78.1117Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_45_2674",
    x: 0,
    y: 0,
    width: 204,
    height: 204,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_45_2674"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 28.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.196078 0 0 0 0 0.481569 0 0 0 0 0.745098 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_45_2674",
    result: "effect2_dropShadow_45_2674"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_45_2674",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToothRestorationIcon);
export default __webpack_public_path__ + "static/media/tooth_restoration_icon.aaeea7fcc044f4d6544467de607c1f14.svg";
export { ForwardRef as ReactComponent };